<template>
  <div class="order-list-page">
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#3ea56e"
      size="128"
      is-full-screen
    />
    
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>

    <v-layout v-else wrap justify-center>
      <v-flex xs12 sm12 md12 lg12 xl12 pa-5>
        
        <!-- Page Header -->
        <div class="page-header mb-5">
          <div class="header-left">
            <div class="header-icon-wrap">
              <v-icon color="white" size="22">mdi-message-text-outline</v-icon>
            </div>
            <div>
              <h2 class="page-title">Contact Messages</h2>
            </div>
          </div>
          <div class="header-actions" v-if="totalData">
            <div class="stat-chip">
              <v-icon size="14" color="#3ea56e" class="mr-1">mdi-message-badge-outline</v-icon>
              <span>{{ totalData }} Total Messages</span>
            </div>
          </div>
        </div>

        <!-- Main Card -->
        <v-card class="modern-card" elevation="0">
          
          <!-- Filters Bar -->
          <div class="filters-bar py-4 px-5">
            <v-row dense>
              <v-col cols="12" sm="4" md="3" class="py-1">
                <v-select
                  dense
                  :items="items"
                  v-model="status"
                  label="Status Filter"
                  outlined
                  clearable
                  hide-details
                  prepend-inner-icon="mdi-filter-variant"
                  class="modern-input"
                ></v-select>
              </v-col>
            </v-row>
          </div>

          <v-divider></v-divider>

          <!-- Data Table -->
          <v-data-table
            :headers="headers"
            :items="user"
            :items-per-page="count"
            hide-default-footer
            class="modern-table"
          >
            <!-- Status Column -->
            <template v-slot:[`item.status`]="{ item }">
              <span :class="['status-badge', getStatusClass(item.status)]">
                {{ item.status }}
              </span>
            </template>

            <!-- Actions Column -->
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                depressed
                class="action-view-btn"
                @click="replayinfo(item._id)"
              >
                <v-icon left size="16">mdi-eye-outline</v-icon>
                <span>View</span>
              </v-btn>
            </template>
            
            <template v-slot:no-data>
              <div class="empty-state">
                <v-icon size="56" color="#cbd5e1">mdi-message-alert-outline</v-icon>
                <p class="empty-title">No messages found</p>
                <p class="empty-subtitle">Try adjusting your filters</p>
              </div>
            </template>
          </v-data-table>

          <!-- Pagination -->
          <div class="pagination-wrap" v-if="pages > 1">
            <div class="pagination-info">
              <span>Page {{ currentPage }} of {{ pages }}</span>
            </div>
            <v-pagination
              :length="pages"
              :total-visible="7"
              v-model="currentPage"
              color="#3ea56e"
              class="modern-pagination"
            ></v-pagination>
          </div>

        </v-card>
      </v-flex>
    </v-layout>

    <!-- Snackbar for Notifications -->
    <v-snackbar
      v-model="showSnackBar"
      color="success"
      :timeout="3000"
      bottom
      right
    >
      {{ msg }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="showSnackBar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      appLoading: false,
      search: "",
      currentPage: 1,
      ServerError: false,
      pages: 0,
      count: 20,
      totalData: 0,
      totalRows: 0,
      showSnackBar: false,
      msg: "",
      status: "",
      headers: [
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "Status", value: "status", align: 'center' },
        { text: "Actions", value: "actions", sortable: false, align: 'center' },
      ],
      items: ["Read", "Unread", "Replied"],
      user: [],
    };
  },
  mounted() {
    this.getData();
  },
  watch: {
    status() {
      this.currentPage = 1;
      this.getData();
    },
    currentPage() {
      this.getData();
    },
  },
  methods: {
    getStatusClass(status) {
      if (!status) return 'status-pending';
      const s = status.toLowerCase();
      if (s === 'unread') return 'status-cancelled'; // Red color
      if (s === 'replied') return 'status-delivered'; // Green color
      if (s === 'read') return 'status-confirmed'; // Blue color
      return 'status-pending';
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/contactus/all/list",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          status: this.status,
          count: this.count,
          page: this.currentPage,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.user = response.data.data;
          this.pages = response.data.pages;
          this.totalData = response.data.count;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    replayinfo(sid) {
      this.$router.push("/contactDetails?id=" + sid);
    },
  },
};
</script>

<style scoped>
/* Page Wrapper */
.order-list-page {
  background: #f5f6fa;
  min-height: 100vh;
  font-family: poppinsmedium, sans-serif;
}

/* Page Header */
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
}
.header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.header-icon-wrap {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #3ea56e, #2d8257);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(62, 165, 110, 0.35);
}
.page-title {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  line-height: 1.2;
}
.header-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.stat-chip {
  display: flex;
  align-items: center;
  background: #e8f5e9;
  border: 1px solid #c8e6c9;
  border-radius: 20px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  color: #2d8257;
  height: 38px;
}

/* Main Card */
.modern-card {
  border-radius: 16px !important;
  border: 1px solid #ebebeb !important;
  overflow: hidden;
  background: #ffffff;
}

/* Filters Bar */
.filters-bar {
  background: #ffffff;
}
.modern-input ::v-deep .v-input__slot {
  border-radius: 10px !important;
  font-size: 13px;
  border-color: #e2e8f0 !important;
}

/* Modern Data Table */
.modern-table ::v-deep th {
  font-size: 12px !important;
  font-weight: 700 !important;
  color: #64748b !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: #f8fafc !important;
  border-bottom: 1px solid #eaedf0 !important;
  padding: 12px 16px !important;
  white-space: nowrap;
}
.modern-table ::v-deep td {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #334155 !important;
  padding: 12px 16px !important;
  border-bottom: 1px solid #f1f5f9 !important;
}
.modern-table ::v-deep tbody tr:hover {
  background-color: #f8fafc !important;
}

/* Action Button */
.action-view-btn {
  border-radius: 10px !important;
  background-color: #e8f5e9 !important;
  color: #2d8257 !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0px !important;
  padding: 8px 18px !important;
  height: 36px !important;
  border: 1px solid #c8e6c9 !important;
  transition: all 0.2s ease !important;
}
.action-view-btn:hover {
  background-color: #3ea56e !important;
  color: #ffffff !important;
  box-shadow: 0 4px 12px rgba(62, 165, 110, 0.25) !important;
  border-color: #3ea56e !important;
}

/* Status Badges */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  border-width: 1px;
  border-style: solid;
}
.status-pending {
  background-color: #fff3e0;
  color: #f76707;
  border-color: #ffa94d33;
}
.status-confirmed {
  background-color: #e7f5ff;
  color: #228be6;
  border-color: #748ffc33;
}
.status-cancelled {
  background-color: #ffe3e3;
  color: #fa5252;
  border-color: #ffa8a833;
}
.status-delivered {
  background-color: #e8f7ee;
  color: #3ea56e;
  border-color: #3ea56e33;
}

/* Empty State */
.empty-state {
  padding: 64px 20px;
  text-align: center;
}
.empty-title {
  font-size: 16px;
  font-weight: 600;
  color: #64748b;
  margin: 12px 0 4px;
}
.empty-subtitle {
  font-size: 13px;
  color: #94a3b8;
  margin: 0;
}

/* Pagination */
.pagination-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 14px 20px;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
}
.pagination-info {
  font-size: 12px;
  color: #9e9e9e;
  font-weight: 500;
}
.modern-pagination ::v-deep .v-pagination__item {
  border-radius: 8px !important;
  font-size: 13px !important;
  min-width: 34px !important;
  height: 34px !important;
  box-shadow: none !important;
}
.modern-pagination ::v-deep .v-pagination__navigation {
  border-radius: 8px !important;
  box-shadow: none !important;
}
</style>
